import { education } from "../../data/portfolio";
import styles from "./Education.module.css";

export default function Education() {
  return (
    <section id="education" className={`section ${styles.education}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">Education</p>
        <h2 className="sectionTitle">Foundation &amp; learning</h2>
      </div>

      <div className={styles.list}>
        {education.map((item) => (
          <article key={item.title} className={styles.item}>
            <div>
              <h3>{item.title}</h3>
              <p>
                {item.school} · {item.place}
              </p>
            </div>
            <div className={styles.meta}>
              <span>{item.period}</span>
              {item.meta ? <strong>{item.meta}</strong> : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
